import axios from "axios";

const softwareRoute = "/api/logiciels";
const serverRoute = "/api/serveurs";
const clientRoute = "/api/clients";
const procedureRoute = "/api/procedures";
const messageRoute = "/api/types-messages";
const userRoute = "/api/utilisateurs";
const loginRoute = "/oauth/token";
const currentUserRoute = process.env.VUE_APP_BASE_URL + "/api/user";

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.headers["Content-Type"] = "application/json";
axios.defaults.headers["Accept"] = "application/json";
/**
 * @description Fonction qui retire les tokens de la session de l'utilisateur et appelle l'api pour faire de même
 * @author Gabriel Bertrand
 */
async function logout() {
  await __postObject("/api/deconnexion")
    .then(() => {
      if (localStorage["refresh_token"] != undefined) {
        localStorage.removeItem("refresh_token");
      } else {
        sessionStorage.removeItem("refresh_token");
      }
      axios.defaults.headers.common.Authorization = null;
    })
    .catch(() => {});
}
/* #region DELETE */
/**
 * @description Méthode qui envoie la commande «effacer un client» à l'api
 * @param {Number} id client à effacer
 * @throws l'erreur retournée par l'api s'il y en a une
 * @returns {JSON} la réponse validée **si la route est mockée, la réponse sera toujours status 200 **
 * @author Gabriel Bertrand
 */
function deleteClient(id) {
  let url = clientRoute + "/" + id;
  return __deleteObject(url);
}
/**
 * @description Méthode qui envoie la commande «effacer un logiciel» à l'api
 * @param {String} id logiciel à effacer
 * @throws l'erreur retournée par l'api s'il y en a une
 * @returns {JSON} la réponse validée **si la route est mockée, la réponse sera toujours status 200 **
 * @author Gabriel Bertrand
 */
function deleteSoftware(id) {
  let url = softwareRoute + "/" + id;
  return __deleteObject(url);
}
/**
 * @description Méthode qui envoie la commande «effacer un serveur» à l'api
 * @param {Number} id serveur à effacer
 * @throws l'erreur retournée par l'api s'il y en a une
 * @returns {JSON} la réponse validée **si la route est mockée, la réponse sera toujours status 200 **
 * @author Gabriel Bertrand
 */
function deleteServer(id) {
  let url = serverRoute + "/" + id;
  return __deleteObject(url);
}
/**
 * @description Méthode qui envoie la commande «effacer un utilisateur» à l'api
 * @param {Number} id utilisateur à effacer
 * @throws l'erreur retournée par l'api s'il y en a une
 * @returns {JSON} la réponse validée **si la route est mockée, la réponse sera toujours status 200 **
 * @author Gabriel Bertrand
 */
function deleteUser(id) {
  let url = userRoute + "/" + id;
  return __deleteObject(url);
}
/**
 * @description Méthode qui envoie la commande «effacer une procédure» à l'api
 * @param {Number} id procédure à effacer
 * @throws l'erreur retournée par l'api s'il y en a une
 * @returns {JSON} la réponse validée **si la route est mockée, la réponse sera toujours status 200 **
 * @author Gabriel Bertrand
 */
function deleteProcedure(id) {
  let url = procedureRoute + "/" + id;
  return __deleteObject(url);
}
/**
 * @description Méthode qui envoie la commande «effacer un message» à l'api
 * @param {Number} id message à effacer
 * @throws l'erreur retournée par l'api s'il y en a une
 * @returns {JSON} la réponse validée **si la route est mockée, la réponse sera toujours status 200 **
 * @author Gabriel Bertrand
 */
function deleteMessage(id) {
  let url = messageRoute + "/" + id;
  return __deleteObject(url);
}

/* #endregion */

/* #region PUT */
/**
 * @description Méthode qui envoie la modification d'un client à l'api
 * @param {Number} id le client qui doit être modifié
 * @param {JSON} data les modifications du client
 * @returns {JSON} la réponse validée
 * @throws l'erreur retournée par l'api s'il y en a une
 * @author Gabriel Bertrand
 */
function editClient(id, data) {
  let url = clientRoute + "/" + id;
  return __putObject(url, data);
}

/**
 * @description Méthode qui envoie la modification d'un logiciel à l'api
 * @param {Number} id le logiciel qui doit être modifié
 * @param {JSON} data les modifications du logiciel
 * @returns {JSON} la réponse validée
 * @throws l'erreur retournée par l'api s'il y en a une
 * @author Gabriel Bertrand
 */
function editSoftware(id, data) {
  let url = softwareRoute + "/" + id;
  return __putObject(url, data);
}

/**
 * @description Méthode qui envoie la modification d'un serveur à l'api
 * @param {Number} id le serveur qui doit être modifié
 * @param {JSON} data les modifications du serveur
 * @returns {JSON} la réponse validée
 * @throws l'erreur retournée par l'api s'il y en a une
 * @author Gabriel Bertrand
 */
function editServer(id, data) {
  let url = serverRoute + "/" + id;
  return __putObject(url, data);
}

/**
 * @description Méthode qui envoie la modification d'une procédure à l'api
 * @param {Number} id la procédure qui doit être modifié
 * @param {JSON} data les modifications de la procédure
 * @returns {JSON} la réponse validée
 * @throws l'erreur retournée par l'api s'il y en a une
 * @author Gabriel Bertrand
 */
function editProcedure(id, data) {
  let url = procedureRoute + "/" + id;
  return __putObject(url, data);
}

/**
 * @description Méthode qui envoie la modification d'un utilisateur à l'api
 * @param {Number} id l'utilisateur qui doit être modifié
 * @param {JSON} data les modifications de l'utilisateur
 * @returns {JSON} la réponse validée
 * @throws l'erreur retournée par l'api s'il y en a une
 * @author Gabriel Bertrand
 */
function editUser(id, data) {
  let url = userRoute + "/" + id;
  return __putObject(url, data);
}

/**
 * @description Méthode qui envoie la modification d'un message à l'api
 * @param {Number} id le message qui doit être modifié
 * @param {JSON} data les modifications du message
 * @returns {JSON} la réponse validée
 * @throws l'erreur retournée par l'api s'il y en a une
 * @author Gabriel Bertrand
 */
function editMessage(id, data) {
  let url = messageRoute + "/" + id;
  return __putObject(url, data);
}

/* #endregion */

/* #region POST */

/**
 * @description Méthode qui envoie le login et reçoit un tokenqui sera renvoyé si les informations sont bonnes
 * @param {String} username nom de l'utilisateur
 * @param {String} password mot de passe de l'utilisateur
 * @throws Erreur retournée par l'api
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function login(username, password) {
  let json =
    '{"grant_type": "password", "client_id" : "' +
    process.env.VUE_APP_CLIENT_ID +
    '", "client_secret" : "' +
    process.env.VUE_APP_CLIENT_SECRET +
    '", "username" : "' +
    username +
    '", "password" : "' +
    password +
    '", "scope" : ""} ';
  let data = JSON.parse(json);
  return __postObject(loginRoute, data);
}

/**
 * @description Méthode qui envoie le login et reçoit un tokenqui sera renvoyé si les informations sont bonnes
 * @param {String} refreshToken « refresh_token » à utiliser
 * @throws Erreur retournée par l'api
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function loginWithToken(refreshToken) {
  let json =
    '{"grant_type": "refresh_token", "client_id": "' +
    process.env.VUE_APP_CLIENT_ID +
    '", "client_secret": "' +
    process.env.VUE_APP_CLIENT_SECRET +
    '", "refresh_token": "' +
    refreshToken +
    '", "scope": ""}';
  let data = JSON.parse(json);
  return __postObject(loginRoute, data);
}

/**
 * @description Méthode qui ajoute un client
 * @param {JSON} data données du formulaire d'ajout pour un client,
 * les noms des clés json doivent respecter ceux du document JSON envoyés par l'équipe de l'API
 * @throws Erreur retournée par l'api
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function addClient(data) {
  return __postObject(clientRoute, data);
}
/**
 * @description Méthode qui ajoute un serveur
 * @param {JSON} data données du formulaire d'ajout pour un serveur,
 * les noms des clés json doivent respecter ceux du document JSON envoyés par l'équipe de l'API
 * @throws Erreur retournée par l'api
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function addServer(data) {
  return __postObject(serverRoute, data);
}
/**
 * @description Méthode qui ajoute un logiciel
 * @param {JSON} data données du formulaire d'ajout pour un logiciel,
 * les noms des clés json doivent respecter ceux du document JSON envoyés par l'équipe de l'API
 * @throws Erreur retournée par l'api
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function addSoftware(data) {
  return __postObject(softwareRoute, data);
}

/**
 * @description Méthode qui ajoute une procédure
 * @param {JSON} data données du formulaire d'ajout pour une procédure,
 * les noms des clés json doivent respecter ceux du document JSON envoyés par l'équipe de l'API
 * @throws Erreur retournée par l'api
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function addProcedure(data) {
  return __postObject(procedureRoute, data);
}
/**
 * @description Méthode qui ajoute un utilisateur
 * @param {JSON} data données du formulaire d'ajout pour un utilisateur,
 * les noms des clés json doivent respecter ceux du document JSON envoyés par l'équipe de l'API
 * @throws Erreur retournée par l'api
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function addUser(data) {
  return __postObject(userRoute, data);
}
/**
 * @description Méthode qui ajoute un message
 * @param {JSON} data données du formulaire d'ajout pour un message,
 * les noms des clés json doivent respecter ceux du document JSON envoyés par l'équipe de l'API
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function addMessage(data) {
  return __postObject(messageRoute, data);
}

/**
 * @description Méthode qui met en sourdine les emails pour un logiciel
 * @param {Number} id id du logiciel
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function doNotDisturbEmail(id) {
  return __postObject(softwareRoute + "/" + id + "/sourdine-email");
}
/* #endregion */

/* #region GET */

/**
 * @description Fonction qui sert à récupérer les utilisateur d'un client du serveur selon l'id donné
 * @param {Number} id id du client recherché
 * @throws le statut de l'erreur s'il y en a une
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getClientUsers(id) {
  return __getObject(clientRoute + "/" + id + "/utilisateurs");
}

/**
 * @description Fonction qui sert à récupérer l'utilisateur actuel
 * @throws le statut de l'erreur s'il y en a une
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getCurrentUser() {
  return __getObject("/api/user");
}

/**
 * @description Fonction qui sert à récupérer un utilisateur du serveur selon l'id donné
 * @param {Number} id id de l'utilisateur recherché
 * @throws le statut de l'erreur s'il y en a une
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getUser(id) {
  return __getObject(userRoute + "/" + id);
}

/**
 * @description Récupère et retourne les informations relatives à l'utilisateur connecté
 * @returns {Object} Le résultat de la requête
 */
function getUserInfo() {
  return axios.get(currentUserRoute);
}

/**
 * @description Fonction qui sert à récupérer un message du serveur selon l'id donné
 * @param {Number} id id du message recherché
 * @throws le statut de l'erreur s'il y en a une
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getMessage(id) {
  let url = messageRoute + "/" + id;
  return __getObject(url);
}

/**
 * @description Fonction qui récupère la liste des messages
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getMessages() {
  return __getObject(messageRoute);
}

/**
 * @description Fonction qui récupère la liste des procédures
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getProcedures() {
  return __getObject(procedureRoute);
}

/**
 * @description Fonction qui sert à récupérer une procédure du serveur selon l'id donné
 * @param {Number} id id du procédure recherché
 * @throws le statut de l'erreur s'il y en a une
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getProcedure(id) {
  let url = procedureRoute + "/" + id;
  return __getObject(url);
}

/**
 * @description Fonction qui récupère la liste des logiciels
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getSoftwares() {
  return __getObject(softwareRoute);
}
/**
 * @description Fonction qui sert à récupérer un logiciel du serveur selon l'id donné
 * @param {Number} id id du logiciel recherché
 * @throws le statut de l'erreur s'il y en a une
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getSoftware(id) {
  let url = softwareRoute + "/" + id;
  return __getObject(url);
}

/**
 * @description Fonction qui récupère les logiciels du serveur
 * @param {Number} id id du serveur
 * @param {String} url l'url d'une requête provenant de la pagination
 * @returns {JSON} la réponse validée ou une erreur
 * @author Samuel Colassin
 */
function getSoftwaresByServer(id, url) {
  let defaultUrl = serverRoute + "/" + id + "/logiciels";
  return url !== "" ? __getObject(url) : __getObject(defaultUrl);
}
/**
 * @description Fonction qui récupère la liste des serveurs pour un client
 * @param {String} url url pour la pagination
 * @param {Number} id id du client
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getServersByClient(id, url = "") {
  return url !== ""
    ? __getObject(url)
    : __getObject(clientRoute + "/" + id + "/serveurs");
}
/*
 * Fonction qui récupère la liste des serveurs pour un client non paginé
 * @param {Number} id - id du client
 * @returns {JSON} la réponse validée ou un erreur
 */
function getServersByClientNotPaginated(id) {
  return __getObject(clientRoute + "/" + id + "/serveurs-non-pagine");
}

/**
 * @description Fonction qui récupère la liste des serveurs pour un client non paginé
 * @param {Number} id - id du client
 * @returns {JSON} la réponse validée ou un erreur
 * @author Alexandre Gallant
 */
function getAllServersByClient(id) {
  return __getObject(clientRoute + "/" + id + "/serveurs-non-pagine");
}

/**
 * @description Fonction qui récupère la liste des serveurs
 * @param {String} url - url pour la pagination
 * @returns {JSON} la réponse validée ou un erreur
 * @author Gabriel Bertrand
 */
function getServers(url = "") {
  return url !== "" ? __getObject(url) : __getObject(serverRoute);
}
/**
 * @description Fonction qui sert à récupérer un serveur du serveur selon l'id donné.
 * @param {Number} id id du serveur recherché
 * @throws le statut de l'erreur s'il y en a une
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getServer(id) {
  return __getObject(serverRoute + "/" + id);
}
/**
 * @description Récupère les informations des disques d'un serveur
 * @returns {JSON} les informations des disques du serveur
 * @param {String} id l'id du serveur
 */
function getServerDisksStates(id) {
  return __getObject(serverRoute + "/" + id + "/disques");
}
/**
 * @description Fonction qui récupère la liste des clients
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getClients() {
  return __getObject(clientRoute);
}

/**
 * @description Fonction qui récupère la liste des clients non paginée
 * @returns {JSON} la réponse validée ou une erreur
 */
function getClientNotPaginated() {
  return __getObject("/api/clients-non-paginee");
}

/**
 * @description Fonction qui récupère la liste des états de chaque logiciel pour un client
 * @param {Number} id id du client
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getClientSoftwareStates(id) {
  return __getObject(clientRoute + "/" + id + "/obtenir-etat-logiciels");
}

/**
 * @description Fonction qui sert à récupérer un client du serveur selon l'id donné
 * @param {Number} id id du client recherché
 * @throws le statut de l'erreur s'il y en a une
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getClient(id) {
  let url = clientRoute + "/" + id;
  return __getObject(url);
}

/**
 * @description Fonction qui sert à récupérer les logiciels d'un client
 * @param {Number} id id du client
 * @param {String}  url url de la pagination
 * @throws le statut de l'erreur s'il y en a une
 * @returns {JSON} la réponse validée ou une erreur
 * @author Félix Bordage
 * @author Maxime Boisvert
 */
function getSoftwaresByClient(id, url = "") {
  let defaultUrl = clientRoute + "/" + id + "/logiciels-non-pagine";
  return url !== "" ? __getObject(url) : __getObject(defaultUrl);
}

/**
 * @description Fonction qui sert à récupérer les types d'erreurs et leur seuils pour un logiciel
 * @param {Number} id id du logiciel en question
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getSoftwareErrorThresholds(id) {
  return __getObject(softwareRoute + "/" + id + "/types-messages");
}

/**
 * @description Fonction qui sert à récupérer l'historique du dernier mois d'un logiciel donné
 * @param {Number} id id du logiciel recherché
 * @throws le statut de l'erreur s'il y en a une
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getSoftwareMonthHistory(id, url) {
  let defaultUrl = softwareRoute + "/" + id + "/obtenir-bascules-mensuelles";
  return url !== "" ? __getObject(url) : __getObject(defaultUrl);
}

/**
 * @description Fonction qui donne le nombre de pannes des 6 derniers mois
 * @param {Number} id l'id du client
 * @returns {JSON} la réponse validée ou une erreur
 * @author Benjamin Caron
 */
function getBreakdownsLastSixMonths(id) {
  let url = clientRoute + "/" + id + "/critiques";
  return __getObject(url);
}

/**
 * @description Fonction qui donne le nombre de notifications des 6 derniers mois
 * @param {Number} id l'id du client
 * @returns {JSON} la réponse validée ou une erreur
 * @author Benjamin Caron
 */
function getNotificationsLastSixMonths(id) {
  let url = clientRoute + "/" + id + "/notifications-six-mois";
  return __getObject(url);
}

/**
 * @description Fonction qui donne le nombre de notifications du client dans la dernière semaine
 * @param {Number} clientId l'id du client
 * @returns {JSON} la réponse validée ou une erreur
 * @author Philippe Ménard
 */
function getClientNotificationLastWeek(clientId) {
  let url = clientRoute + "/" + clientId + "/obtenir-stats-notifications";
  return __getObject(url);
}

/**
 * @description Fonction qui donne le nombre de notifications dans la dernière semaine
 * @returns {JSON} la réponse validée ou une erreur
 * @author Philippe Ménard
 */
function getNotificationStatsAllClients() {
  let url = clientRoute + "/" + "obtenir-stats-notifications";
  return __getObject(url);
}

/**
 * @description Fonction qui sert à récupérer les erreurs critiques d'un logiciel
 * @param {Number} id id du logiciel en question
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getSoftwareCriticals(id) {
  return __getObject(softwareRoute + "/" + id + "/critiques");
}

/**
 * @description Fonction qui sert à récupérer les erreurs d'avertissement d'un logiciel
 * @param {Number} id id du logiciel en question
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getSoftwareWarnings(id) {
  return __getObject(softwareRoute + "/" + id + "/avertissements");
}

/**
 * @description Fonction qui sert à récupérer l'historique de la dernière année d'un logiciel donné
 * @param {Number} id id du logiciel recherché
 * @throws le statut de l'erreur s'il y en a une
 * @returns {JSON} la réponse validée ou une erreur
 * @author Gabriel Bertrand
 */
function getSoftwareYearHistory(id, url) {
  let defaultUrl = softwareRoute + "/" + id + "/obtenir-bascules-annuelles";
  return url !== "" ? __getObject(url) : __getObject(defaultUrl);
}

/**
 * @description Fonction qui sert à récupérer l'historique des avertissements des x derniers mois demandés d'un logiciel donné
 * @param {Number} id id du logiciel recherché
 * @throws le statut de l'erreur s'il y en a une
 * @returns {JSON} la réponse validée ou une erreur
 * @author Francine Jin
 */
async function getSoftwareWarning(id) {
  let url = softwareRoute + "/" + id + "/avertissements";
  return __getObject(url);
}

/**
 * @description Fonction qui sert à récupérer l'historique des erreurs critiques des x derniers mois demandés d'un logiciel donné
 * @param {Number} id id du logiciel recherché
 * @throws le statut de l'erreur s'il y en a une
 * @returns {JSON} la réponse validée ou une erreur
 * @author Francine Jin
 */
async function getSoftwareErrorsCritics(id) {
  let url = softwareRoute + "/" + id + "/critiques";
  return __getObject(url);
}

/**
 * @description Fonction qui sert à récupérer tous les logiciels critiques de tous les clients
 * @param {String} url l'url d'une requête provenant de la pagination
 * @returns {JSON} la réponse validée ou une erreur
 * @author Francine Jin
 */
async function getAllSoftwaresCritics(url) {
  let defaultUrl = softwareRoute + "/obtenir-tous-logiciels-critiques";
  return url !== "" ? __getObject(url) : __getObject(defaultUrl);
}

/**
 * @description Fonction qui sert à récupérer tous les logiciels en état d'avertissement de tous les clients
 * @param {String} url l'url d'une requête provenant de la pagination
 * @returns {JSON} la réponse validée ou une erreur
 * @author Alexandre Gallant
 */
async function getAllSoftwaresWarnings(url) {
  let defaultUrl = softwareRoute + "/obtenir-tous-logiciels-avertis";
  return url !== "" ? __getObject(url) : __getObject(defaultUrl);
}

/* #endregion */

/* #region API request methods */
async function __getObject(url) {
  try {
    let response = await axios.get(url);
    return response;
  } catch (e) {
    return e.response;
  }
}

async function __putObject(url, data) {
  try {
    let response = await axios.put(url, data);
    return response;
  } catch (e) {
    return e.response;
  }
}

async function __postObject(url, data) {
  try {
    let response = await axios.post(url, data);
    return response;
  } catch (e) {
    return e.response;
  }
}

async function __deleteObject(url) {
  try {
    let response = await axios.delete(url);
    return response;
  } catch (e) {
    return e.response;
  }
}
/* #endregion */
export {
  axios,
  login,
  loginWithToken,
  getClient,
  getClients,
  getClientNotPaginated,
  getServer,
  getServersByClient,
  getAllServersByClient,
  getServers,
  getServerDisksStates,
  getSoftware,
  getSoftwareCriticals,
  getSoftwareWarnings,
  getSoftwares,
  getSoftwaresByServer,
  getServersByClientNotPaginated,
  getMessage,
  getMessages,
  getProcedure,
  getProcedures,
  getUser,
  getUserInfo,
  getCurrentUser,
  getClientUsers,
  getSoftwareMonthHistory,
  getSoftwareYearHistory,
  getSoftwareErrorsCritics,
  getSoftwareWarning,
  getSoftwaresByClient,
  getSoftwareErrorThresholds,
  getBreakdownsLastSixMonths,
  getNotificationsLastSixMonths,
  getAllSoftwaresCritics,
  getAllSoftwaresWarnings,
  getClientNotificationLastWeek,
  getNotificationStatsAllClients,
  addClient,
  getClientSoftwareStates,
  addMessage,
  addProcedure,
  addServer,
  addSoftware,
  addUser,
  editClient,
  editMessage,
  editProcedure,
  editServer,
  editSoftware,
  editUser,
  deleteClient,
  deleteMessage,
  deleteProcedure,
  deleteServer,
  deleteSoftware,
  deleteUser,
  doNotDisturbEmail,
  logout
};
